import SidebarSectionItem from "@/components/sidebar/sidebar-components/sidebar-section-item";
import React from "react";
import { useGlobalModalContext } from "@/providers/modal-provider/modal-provider";

interface LinksSidebarSectionProps {
  style: string;
}

const LinksSidebarSection = ({ style }: LinksSidebarSectionProps) => {
  const { showModal } = useGlobalModalContext();
  return (
    <div className={style}>
      <SidebarSectionItem
        title={"Affiliate"}
        href={""}
        onClick={() => showModal({ type: "affiliate_modal" })}
      />
      <SidebarSectionItem
        title={"Our Products"}
        href={"/our-products"}
        hrefTarget={"_blank"}
      />
      <SidebarSectionItem
        title={"Learn"}
        href={"https://audiomodify.com/blog"}
        hrefTarget={"_blank"}
      />
      <SidebarSectionItem title={"API"} href={"/request-api"} />
      <SidebarSectionItem title={"Plans and pricing"} href={"/pricing"} />
    </div>
  );
};

export default LinksSidebarSection;
